import api from "./axios";

export const getMyEmployeeOperations = () =>
  api.get("/employee-operations/me");

export const updateMyEmployeeOperations = (data) =>
  api.patch("/employee-operations/me", data);

export const sendEmployeeOperationsHeartbeat = () =>
  api.post("/employee-operations/heartbeat");

export const getEmployeeOperationMembers = () =>
  api.get("/employee-operations/members");

export const getWaitingConversations = (params = {}) =>
  api.get("/employee-operations/waiting", { params });
